import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import { Grid, Stack } from "@mui/material";

const useStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        flexWrap: "wrap",
    },
    btnWrapper: {
        position: "relative",
    },
    buttonProgress: {
        color: green[500],
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
}));

const FlowBuilderAddTransferConnectionModal = ({
    open,
    onSave,
    data,
    onUpdate,
    close,
}) => {
    const classes = useStyles();
    const isMounted = useRef(true);
    const [activeModal, setActiveModal] = useState(false);
    const [connections, setConnections] = useState([]);
    const [selectedConnection, setSelectedConnection] = useState("");

    useEffect(() => {
        if (open === "edit") {
            (async () => {
                try {
                    const connection = data?.data?.connection;
                    const { data: result } = await api.get("/whatsapp/?session=0");
                    const list = Array.isArray(result)
                        ? result
                        : result?.whatsapps || [];

                    setConnections(list);
                    setSelectedConnection(connection?.id || "");
                    setActiveModal(true);
                } catch (error) {
                    console.log(error);
                }
            })();
        } else if (open === "create") {
            (async () => {
                try {
                    const { data: result } = await api.get("/whatsapp/?session=0");
                    const list = Array.isArray(result)
                        ? result
                        : result?.whatsapps || [];

                    setConnections(list);
                    setSelectedConnection("");
                    setActiveModal(true);
                } catch (error) {
                    console.log(error);
                }
            })();
        }

        return () => {
            isMounted.current = false;
        };
    }, [open, data]);

    const handleClose = () => {
        close(null);
        setActiveModal(false);
    };

    const handleSave = () => {
        if (!selectedConnection) {
            return toast.error("Selecione uma conexao de destino");
        }

        const connection = connections.find(
            item => item.id === selectedConnection
        );

        if (!connection) {
            return toast.error("Conexao selecionada invalida");
        }

        if (open === "edit") {
            onUpdate({
                ...data,
                data: {
                    connection,
                },
            });
        } else if (open === "create") {
            onSave({
                connection,
            });
        }

        handleClose();
    };

    return (
        <div className={classes.root}>
            <Dialog
                open={activeModal}
                onClose={handleClose}
                fullWidth="md"
                scroll="paper"
            >
                <DialogTitle id="form-dialog-title">
                    {open === "create"
                        ? "Adicionar transferencia de conexao"
                        : "Editar transferencia de conexao"}
                </DialogTitle>
                <Stack>
                    <DialogContent dividers>
                        <Grid style={{ width: "100%", marginTop: 40 }} container>
                            <Typography>Escolha a conexao de destino</Typography>
                            <Select
                                labelId="transfer-connection-label"
                                id="transfer-connection-select"
                                value={selectedConnection}
                                style={{ width: "95%" }}
                                onChange={e => {
                                    setSelectedConnection(e.target.value);
                                }}
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left",
                                    },
                                    transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left",
                                    },
                                    getContentAnchorEl: null,
                                }}
                                renderValue={() => {
                                    if (selectedConnection === "") {
                                        return "Selecione uma conexao";
                                    }

                                    const connection = connections.find(
                                        item => item.id === selectedConnection
                                    );

                                    if (!connection) {
                                        return "Selecione uma conexao";
                                    }

                                    return connection.name;
                                }}
                            >
                                <MenuItem value="">
                                    <em>Selecione uma conexao</em>
                                </MenuItem>

                                {connections.length > 0 &&
                                    connections.map((item, index) => (
                                        <MenuItem dense key={index} value={item.id}>
                                            {item.name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="secondary" variant="outlined">
                            {i18n.t("contactModal.buttons.cancel")}
                        </Button>
                        <Button
                            type="submit"
                            color="primary"
                            variant="contained"
                            className={classes.btnWrapper}
                            onClick={handleSave}
                        >
                            {open === "create" ? "Adicionar" : "Editar"}
                        </Button>
                    </DialogActions>
                </Stack>
            </Dialog>
        </div>
    );
};

export default FlowBuilderAddTransferConnectionModal;
